// filepath: apps/web/src/editors/bpm-designer/BpmNodePalette.tsx
//
// FR-UI-BLD-1 AC-3 - left-hand node palette. 7 canonical node types
// (FR-BPM-1). Each tile is a drag source (`nodeType`).
//
// The drag handle is rendered via HTML5 drag-and-drop - the node type
// is carried in the dataTransfer payload.

import React from "react";
import { useTranslation } from "react-i18next";
import { ALL_NODE_TYPES, type NodeType } from "./types";

interface BpmNodePaletteProps {
  onDragNodeType: (nodeType: NodeType) => void;
}

export function BpmNodePalette({
  onDragNodeType,
}: BpmNodePaletteProps): React.ReactElement {
  const { t } = useTranslation();
  return (
    <aside
      className="bpm-node-palette"
      aria-label={t("admin.designer.palette.aria")}
      data-testid="bpm-node-palette"
    >
      <h2 className="bpm-node-palette__title">
        {t("admin.designer.palette.title")}
      </h2>
      <ul className="bpm-node-palette__list">
        {ALL_NODE_TYPES.map((nt) => (
          <li
            key={nt}
            className="bpm-node-palette__item"
            draggable
            onDragStart={(e) => {
              e.dataTransfer.setData("nodeType", nt);
              onDragNodeType(nt);
            }}
            data-testid={`palette-item-${nt}`}
            data-node-type={nt}
          >
            {t(`admin.designer.node_types.${nt}`)}
          </li>
        ))}
      </ul>
    </aside>
  );
}
